<template>
  <div class="edit-gate-info">
    <v-form ref="formEditGate" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="5">
          <div class="edit-gate-info__section">
            <h2 class="edit-gate-info__section-title">
              <v-icon left small>mdi-information-outline</v-icon>
              Данные о калитке
            </h2>
            <v-row class="edit-gate-info__form-row">
              <v-col cols="12" class="edit-gate-info__col">
                <v-combobox
                  v-model="formGate.address"
                  @keyup="startTypingTimer"
                  @input="updateAddressSearch"
                  ref="addressInput"
                  prepend-inner-icon="mdi-rename-box-outline"
                  :rules="[() => !!formGate.address || 'Обязательное поле']"
                  :items="isFirstLoading ? [formGate.address] : addresses"
                  item-text="addresses"
                  return-object
                  label="Адрес"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" class="edit-gate-info__col">
                <v-autocomplete
                  label="Район (только для г. Саранск)"
                  v-model="formGate.region"
                  :items="district"
                  :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                  item-value="id"
                  prepend-inner-icon="mdi-map-marker-radius-outline"
                  outlined
                  dense
                  hide-details
                  :disabled="!isDistrict"
                />
              </v-col>
              <v-col cols="12" class="edit-gate-info__col">
                <v-text-field
                  label="Название в моб. приложении"
                  v-model="formGate.name"
                  prepend-inner-icon="mdi-rename-outline"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>
              <v-col cols="12" class="edit-gate-info__col">
                <v-autocomplete
                  label="Физический статус"
                  prepend-inner-icon="mdi-progress-clock"
                  :items="physicalStatus"
                  v-model="formGate.physicalStatus"
                  :rules="[() => !!formGate.physicalStatus || 'Обязательное поле']"
                  item-text="status"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>
              <v-col cols="12" class="edit-gate-info__col">
                <v-text-field
                  label="Комментарий"
                  v-model="formGate.comment"
                  prepend-inner-icon="mdi-comment-outline"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col v-if="roleName === 'admin'" cols="12" class="edit-gate-info__col">
                <v-checkbox
                  v-model="formGate.hidden"
                  label="Отображение в мобильном приложении"
                  hide-details
                  dense
                  color="primary"
                />
              </v-col>
              <v-col cols="12" class="edit-gate-info__col">
                <BindingDoorphone />
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-col cols="12" md="7">
          <div v-if="currentDevice" class="edit-gate-info__current-device">
            <v-icon left color="success">mdi-check-circle-outline</v-icon>
            {{ currentDevice }}
          </div>

          <div class="edit-gate-info__card mt-3">
            <div class="edit-gate-info__filters">
              <div class="edit-gate-info__filters-title">
                <v-icon left small>mdi-devices</v-icon>
                Устройства
              </div>
              <div class="edit-gate-info__filters-row">
                <v-text-field
                  v-model="searchDevice"
                  label="Поиск по IP-адресу"
                  outlined
                  dense
                  hide-details
                  class="edit-gate-info__field"
                  autocomplete="off"
                  @keyup="(e) => e.keyCode === 13 && filterDevices()"
                />
                <v-btn
                  color="primary"
                  class="text-none edit-gate-info__search-btn"
                  dark
                  rounded
                  @click.prevent="filterDevices"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Поиск
                </v-btn>
              </div>
            </div>
            <v-data-table
              class="edit-gate-info__table"
              v-model="selectedDevices"
              :options.sync="universalOptions"
              :server-items-length="universalTotalDevices"
              :headers="headersDevicesEdit"
              :items="getItemsDevices"
              item-key="id"
              show-select
              :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
              :single-select="true"
              :disable-sort="true"
            />
            <div class="edit-gate-info__table-actions">
              <v-btn
                v-if="$checkPermission('edit_barrier')"
                :disabled="!selectedDevices.length"
                color="success"
                class="text-none"
                dark
                rounded
                @click="validate"
              >
                <v-icon left>mdi-swap-horizontal</v-icon>
                Сменить устройство
              </v-btn>
            </div>
          </div>

          <div class="edit-gate-info__section mt-4">
            <h2 class="edit-gate-info__section-title">Изображение</h2>
            <v-img
              :src="require('../../../../../public/controller.jpg')"
              max-width="300"
              contain
              class="edit-gate-info__image"
            />
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <div class="edit-gate-info__actions">
        <div class="edit-gate-info__actions-left">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            @click="validate()"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            Сохранить
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="text-none"
            rounded
            @click.prevent="returnGate"
          >
            <v-icon left>mdi-close</v-icon>
            Отменить
          </v-btn>
        </div>
        <v-btn
          color="error"
          outlined
          class="text-none"
          rounded
          @click.stop="dialogWarning = true"
        >
          <v-icon left>mdi-delete-outline</v-icon>
          Удалить калитку
        </v-btn>
      </div>

      <v-dialog v-model="dialogWarning" width="500" content-class="dialog-border-radius" persistent>
        <BaseDeleteModal
          :active.sync="dialogWarning"
          @close="dialogWarning = false"
          @submit="remove()"
          messageTitle="Удалить калитку?"
          messageText="Подтверждая, вы удалите калитку."
          confirmText="Удалить"
          cancelText="Отмена"
          confirmColor="error"
        />
      </v-dialog>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { headersDevicesEdit, physicalStatus } from '../../consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';
import BaseDeleteModal from '../../../BaseDeleteModal';
import BindingDoorphone from './BindingDoorphone';

export default {
  name: 'GeneralInfo',
  components: { BaseDeleteModal, BindingDoorphone },
  mixins: [watchTableOptions],
  props: ['returnGate'],
  data: () => {
    return {
      isFirstLoading: true,
      dialog: false,
      physicalStatus,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalTotalDevices: 0,
      selectedDevices: [],
      dialogWarning: false,
      headersDevicesEdit,
      dialogImage: false,
      isDistrict: false,
      valid: true,
      searchDevice: '',
      currentDevice: '',
      searchAddress: '',
      typingTimer: null,
      formGate: {
        address: { addresses: '' },
        name: '',
        physicalStatus: '',
        region: null,
        model: '',
        deviceId: null,
        comment: '',
        hidden: null,
      },
      isMobile: false,
    };
  },
  computed: {
    ...mapGetters({
      district: 'Doorphone/districts',
      gateEdit: 'Gate/gateEdit',
      addresses: 'Doorphone/addresses',
      devices: 'Device/devices',
      roleName: 'roleName',
    }),
    getItemsDevices () {
      return this.devices.filter(device => device.id !== this.formGate.deviceId);
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  created () {
    this.currentDevice = 'Текущее устройство: ' + this.gateEdit.gate.ip_address;
    this.addresses[0] = this.gateEdit.gate.address;
    this.formGate.address.addresses = this.gateEdit.gate.address;
    this.formGate.model = this.gateEdit.gate.model;
    this.formGate.agent_id = this.gateEdit.gate.agent_id;
    this.formGate.deviceId = this.gateEdit.gate.device_id;
    this.formGate.comment = this.gateEdit.gate.comment;
    this.formGate.hidden = this.gateEdit.gate.display_in_app;
    this.formGate.physicalStatus = this.gateEdit.gate.physical_status;
    if (this.gateEdit.gate.name) {
      this.formGate.name = this.gateEdit.gate.name;
    }

    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
    const filters = ({
      free: 1,
      agent_id: this.formGate.agent_id,
      'model.name': this.formGate.model,
    });
    this.loadDevices({
      filters,
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      })
      .catch((e) => {
        console.error(e);
        this.$flash_warning('Ошибка при загрузке устройств');
      });
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      getAddressSearch: 'Doorphone/getAddressSearch',
      removeGate: 'Gate/removeGate',
      updateGate: 'Gate/updateGate',
    }),
    updateAddressSearch () {
      const val = this.formGate.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formGate.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.formGate.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = ({
        free: 1,
        agent_id: this.formGate.agent_id,
        'model.name': this.formGate.model,
      });

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    remove () {
      this.removeGate({ id: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: 'Gates' });
          this.$flash_success('Изменения сохранены!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении');
        });
    },
    async validate () {
      await this.$refs.addressInput.blur();
      let tempDevice;
      if (!this.selectedDevices.length) {
        tempDevice = this.formGate.deviceId;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      if (this.$refs.formEditGate.validate()) {
        const tempGate = {
          device_id: tempDevice,
          physical_status: this.formGate.physicalStatus,
          name: this.formGate.name,
          display_in_app: this.formGate.hidden,
        };
        if (this.formGate.region && this.isDistrict) {
          tempGate.region_id = this.formGate.region;
        }
        if (this.gateEdit.doorphones[0]) {
          tempGate.doorphones = this.gateEdit.doorphones.map(item => item.id);
        }
        tempGate.comment = this.formGate.comment;
        if (typeof this.formGate.address === 'object') {
          tempGate.address = this.formGate.address.addresses;
        } else {
          tempGate.address = this.formGate.address;
        }
        if (this.formGate.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.updateGate({
            id: this.$route.params.id,
            params: tempGate,
          })
            .then(() => {
              this.$router.push({ name: 'DetailGate', params: { id: this.$route.params.id } });
              this.$flash_success('Изменения успешно сохранены');
            })
            .catch((message) => {
              if (message.length > 0) {
                for (let i = 0; i < message.length; i++) {
                  this.$flash_warning(message[i]);
                  console.error(message);
                  this.$sentry_exception(message);
                }
              } else {
                this.$flash_warning('Ошибка при изменении информации');
              }
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.edit-gate-info__section {
  margin-bottom: 0;
}

.edit-gate-info__section-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
}

.edit-gate-info__form-row {
  margin: 0 -12px;
}

.edit-gate-info__col {
  padding-top: 0;
  padding-bottom: 12px;
}

.edit-gate-info__current-device {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(76, 175, 80, 0.08);
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 12px;
  font-size: 0.9375rem;
  color: #2e7d32;
}

.edit-gate-info__card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  overflow: hidden;
}

.edit-gate-info__filters {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.edit-gate-info__filters-title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.edit-gate-info__filters-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.edit-gate-info__field {
  flex: 1;
  min-width: 200px;
}

.edit-gate-info__search-btn {
  flex-shrink: 0;
}

.edit-gate-info__table {
  border: none;
}

.edit-gate-info__table-actions {
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.edit-gate-info__image {
  border-radius: 8px;
  overflow: hidden;
}

.edit-gate-info__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.edit-gate-info__actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

::v-deep .dialog-border-radius {
  border-radius: 12px;
}
</style>
